<template>
  <div class="i0009">
    <div class="i0009-title">
      <!-- 本人書類確認 -->
      <p>{{$t('MODULE.I0009_LBL_SELF_CONFIRM')}}</p>
    </div>
    <div class="i0009-main-border">
      <el-row>
        <el-col :span="5">
          <!-- 確認資料 -->
          <div class ="i0009-row_div-text" style="margin-right:10px;">{{$t('MODULE.I0009_LBL_DATA_CONFIRM')}}</div>
        </el-col>
        <el-col :span="19">
          <el-select style="width: 100%;" v-model="selectValue" :placeholder=" $t('COMMON.PLACEHOLDER_SELECT')" @change="confirmSelect" @visible-change="selectBeforeChange($event)">
            <el-option v-for="item in selectData" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row v-if="selectType==='1'" style="margin-top:10px;">
        <el-col :span="5">
          <!-- 表面 -->
          <div class ="i0009-row_div-text"></div>
        </el-col>
        <el-col :span="19">
          <div class="i0009_photo_border" v-if="!positiveUrl" :class="{'positiveCss': positiveCss}"></div>
          <el-upload class="i0009_photo_upload" ref="positive" :file-list="positiveList" :show-file-list="true" list-type="picture-card" :limit="limitNum" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'positive','1')}" :auto-upload="false" multiple>
            <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
            <template slot="file" slot-scope="{file}">
              <img id="positiveImg" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions" @click="handlePhotoPreview(file,'positive')">
                <span v-if="positiveLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'positive','1')}">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </template>
          </el-upload>
          <!--图片预览用dialog-->
          <el-image-viewer v-if="positiveDialog" :on-close="positivePhotoDelete" :url-list="[positiveUrl]" />
        </el-col>
      </el-row>
      <el-row v-if="selectType==='2'" style="margin-top:10px;">
        <el-col :span="5">
          <!-- 表面 -->
          <div class ="i0009-row_div-text">{{$t('MODULE.I0009_LBL_FRONT_SIDE')}}</div>
        </el-col>
        <el-col :span="19">
          <div class="i0009_photo_border" v-if="!positiveUrl" :class="{'positiveCss': positiveCss}"></div>
          <el-upload class="i0009_photo_upload" ref="positive" :file-list="positiveList" :show-file-list="true" list-type="picture-card" :limit="limitNum" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'positive','1')}" :auto-upload="false" multiple>
            <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
            <template slot="file" slot-scope="{file}">
              <img id="positiveImg" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions" @click="handlePhotoPreview(file,'positive')">
                <span v-if="positiveLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'positive','1')}">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </template>
          </el-upload>
          <!--图片预览用dialog-->
          <el-image-viewer v-if="positiveDialog" :on-close="positivePhotoDelete" :url-list="[positiveUrl]" />
        </el-col>
      </el-row>
      <el-row v-if="selectType==='2'" style="margin-top:10px;">
        <el-col :span="5">
          <!-- 裏面 -->
          <div class ="i0009-row_div-text">{{$t('MODULE.I0009_LBL_BACK_SIDE')}}</div>
        </el-col>
        <el-col :span="19">
          <div class="i0009_photo_border" v-if="!reverseUrl" :class="{'reverseCss': reverseCss}"></div>
          <el-upload class="i0009_photo_upload" ref="reverse" :file-list="reverseList" :show-file-list="true" list-type="picture-card" :limit="limitNum" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'reverse','2')}" :auto-upload="false" multiple>
            <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
            <template slot="file" slot-scope="{file}">
              <img id="reverseImg" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions" @click="handlePhotoPreview(file,'reverse')">
                <span v-if="reverseLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'reverse','1')}">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </template>
          </el-upload>
          <!--图片预览用dialog-->
          <el-image-viewer v-if="reverseDialog" :on-close="reversePhotoDelete" :url-list="[reverseUrl]" />
        </el-col>
      </el-row>
      <el-row v-if="selectType==='2'" style="font-size:12px;color:red;margin-top:10px">
        <!-- ※裏面に何も記載無くても、記載なしの証明として必要です -->
        <span>{{$t('MODULE.I0009_LBL_TEXT')}}</span>
      </el-row>
    </div>
    <div align="left">
      <span style="font-size: 10pt;">{{statusNameLabel}}</span>
    </div>
    <div align="center">
      <!-- 申請 -->
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 10pt;width:20%"  @click="save" type="primary" :disabled="editDisabled">{{$t('MODULE.I0009_LBL_APPLY')}}</el-button>
      <!-- 戻る -->
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 10pt;width:20%" @click="back" type="primary">{{$t('MODULE.I0009_LBL_BACK')}}</el-button>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0009"
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  mixins: [css],
  components: {
    ElImageViewer
  },
  data() {
    return {
      // loading: false,
      // obj: [],
      selectData: [],
      selectValue: '',
      selectValueOld: '',
      selectType: '2', //2:両面, 1:片面
      //processCd:'',//処理区分
      editDisabled: true, //申請ボタン false:活性/true:非活性
      statusNameLabel:'',
      selfDocData: {}, //本人確認書

      limitNum: 2,
      positiveImage: {},
      positiveList: [],
      positiveUrl: '',
      positiveDialog: false,
      positiveLongClick: false,
      positiveCss: false,

      reverseImage: {},
      reverseList: [],
      reverseUrl: '',
      reverseDialog: false,
      reverseLongClick: false,
      reverseCss: false,

      confirmSelectFlag:false,
    }
  },
  created() {  
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
    // ページ:'all' 区分:50 タイプ:'piv_doc_div'
    amsApi.i_0009_conditionSearch('all', '3,50','piv_doc_div').then(res => {
        //確認資料リスト取得
        this.selectData = res.items.generalData.pivDocDiv;
    });

    this.query();
  },
  methods: {
    query() {
      //实现Loading 加载方法
      this.set_loading();
      var params = [];
      //调用服务端接口
      amsApi.i_0009_selfDocSearch(params).then(res => {

        this.confirmSelectFlag = false;
        //検索結果0件以外
        if (res.code == '204') {
          this.selfDocData = res.items.selfDoc[0];
          if ( this.selfDocData.processCd == '1') {//処理区分が「1：更新」場合
            this.statusNameLabel =  this.selfDocData.statusName + ":" ;
            if ( this.selfDocData.status=='0') {//「0」の場合、申請日時
              var applyDate = this.selfDocData.applyDate;
              if (applyDate.length>18) {
                applyDate = applyDate.substr(0,19);
              }
              this.statusNameLabel = this.statusNameLabel +  applyDate;
            } else {//「1,2」の場合、確認日時
              var confirmDate = this.selfDocData.confirmDate;
              if (confirmDate.length>18) {
                confirmDate = confirmDate.substr(0,19);
              }
              this.statusNameLabel = this.statusNameLabel +  confirmDate;
            }
          } else if ( this.selfDocData.processCd == '2'){//2：新規 場合
            this.selectValue = '01';
            this.statusNameLabel = '';
          }

          //処理区分が「1：更新」 and  ステータスが「2：確認済」の場合、
          if ( this.selfDocData.processCd == '1' &&  this.selfDocData.status=='2') {
            this.editDisabled = true;
          } else {
            this.editDisabled = false;
          }

          //レスポンス.本人確認書類
          if ( this.selfDocData.pivDocDiv != '' &&  this.selfDocData.pivDocDiv !=null) {
            this.selectValue = this.selfDocData.pivDocDiv;
          }
          
          // 両面アップロード資料：
          this.showUploadImageControl(this.selectValue);

          //本人書類写真1
          if ( this.selfDocData.pivDocPhoto1 != '' &&  this.selfDocData.pivDocPhoto1 !=null) {
            this.fileQuery(this.selfDocData.pivDocPhoto1,"1");
          }
          //本人書類写真12
          if ( this.selfDocData.pivDocPhoto2 != '' &&  this.selfDocData.pivDocPhoto2 !=null) {
            this.fileQuery(this.selfDocData.pivDocPhoto2,"2");
          }

          if ((this.selfDocData.pivDocPhoto1 == '' || this.selfDocData.pivDocPhoto1 ==null) && (this.selfDocData.pivDocPhoto2 == '' || this.selfDocData.pivDocPhoto2 ==null)) {
            this.close_loading();
          }
        } else if (res.code == '300') {
          
        }
        //this.close_loading()
      }).catch((err) => {
        //关闭loading
        this.close_loading()
      });
    },
    //文件查询
    fileQuery(filePath,filePathType) {
      this.set_loading();
      amsApi.i_0009_photoFileGet(filePath).then(res => {
        let blob = new Blob([res], { type: 'image/jpg' })
        var url = window.URL.createObjectURL(blob)
        //拡張子
        var exhibitionName = filePath.split('.')[1];

        if (filePathType == '1') {
          //本人書類写真1
          this.positiveList.push({ url: url });
          this.positiveUrl = filePath;

          this.positiveImage = {};
          this.positiveImage.name = 'pivDoc1.' + exhibitionName;
          this.positiveImage.files = blob;
          this.positiveImage.photoId = "1";
          this.positiveImage.photoPath = filePath;
          this.positiveImage.type = "1";
        } else if (filePathType == '2') {
          //本人書類写真2
          this.reverseList.push({ url: url });
          this.reverseUrl = filePath;

          this.reverseImage = {};
          this.reverseImage.name = 'pivDoc2.' + exhibitionName;
          this.reverseImage.files = blob;
          this.reverseImage.photoId = "2";
          this.reverseImage.photoPath = filePath;
          this.reverseImage.type = "2";
        }
        this.close_loading()
      }).catch((error) => {
        this.close_loading()
      })
    },
    selectBeforeChange(callback) {  
      if (callback) {
        this.selectValueOld = this.selectValue;
      }
    },
    //  確認資料 
    confirmSelect() {
      if (this.selectValueOld != this.selectValue) {
        //確認資料を切替えるとき、未保存のアップロード写真がある場合
        if ((this.positiveUrl != '' || this.reverseUrl != '') && this.confirmSelectFlag == true ) {
          //var that = this;
          this.$confirm(this.$t('MODULE.I0009_MSG_SELECT_CHANGE'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//いいえ
            center: 'true'
          }).then(() => {
            this.showUploadImageControl(this.selectValue);
            this.positiveUrl = '';
            this.reverseUrl = '';
            this.positiveList = [];
            this.reverseList = [];
          }).catch(() => {
            // 取消
            this.selectValue = this.selectValueOld;
          });
        } else {
          this.showUploadImageControl(this.selectValue);
          this.positiveUrl = '';
          this.reverseUrl = '';
          this.positiveList = [];
          this.reverseList = [];
        }
      }
    },
    showUploadImageControl(val) {
      // 両面アップロード資料：
      // 01: 運転免許証
      if (val == '01') {
        this.selectType = '2'//2:両面
      } else {
        this.selectType = '1'//1:片面
      }
    },
    back() {
      this.$router.push({ path: url.routerUrl_I0002 })
    },
    save() {
      //確認資料入力チェック
      if (this.selectValue == '') {
        this.$message.error({ message: this.$t('MODULE.I0009_MSG_SELF'), showClose: true });
        return;
      }
      //写真（表面）アップロードチェック
      if (this.positiveUrl == '') {
        this.$message.error({ message: this.$t('MODULE.I0009_MSG_PHOTO1'), showClose: true });
        return;
      }
      //両面アップロードの場合のみ、下記のチェックを行う
      if (this.selectType == '2') {
        if (this.reverseUrl == '') {
          this.$message.error({ message: this.$t('MODULE.I0009_MSG_PHOTO2'), showClose: true });
          return;
        }
      }
      //上記チェックがOKでしたら、確認ダイアログ表示
      // 保存処理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), {//保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: 'true'
      }).then(() => {
        // 保存时先进行图片上传，成功之后进行数据更新
        this.photoSave();
      }).catch(() => {
        // 取消
      });
    },
    //添付写真を転送する。
    photoSave() {
      this.set_loading();
      var photoList = [];
      //1:片面
      if (this.selectType == '1') {
        photoList.push(this.positiveImage);
      } else if (this.selectType == '2') {
        photoList.push(this.positiveImage);
        photoList.push(this.reverseImage);
      }

      //check，DB Data和File Data不一致
      var photoListCheckError = false;
      if (this.selectType == '1') {
        if (photoList.length != 1) {
          photoListCheckError = true;
        } else {
          if (photoList[0].photoPath == '') {
            photoListCheckError = true;
          }
        }
      } else if (this.selectType == '2') {
        if (photoList.length != 2) {
          photoListCheckError = true;
        } else {
          if (photoList[0].photoPath == '') {
            photoListCheckError = true;
          } else if (photoList[1].photoPath == '') {
            photoListCheckError = true;
          }
        }
      }
      if (photoListCheckError) {
          this.close_loading();
          //图片上传失败
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
          return;
      }

      //图片批量上传 ，调用一次API
      var photoFormData = new FormData();
      for (let i = 0; i < photoList.length; i++) {
          photoFormData.append('files', photoList[i].files, photoList[i].photoPath);
      }
      if (photoList.length > 0) {
        amsApi.i_0009_saveImage(photoFormData).then(res => {
          if (res.code == 205) {
            // 写真都成功上传后，保存申请参数
            this.dataSave();
          } else if (res.code == 311) {
            this.close_loading();
            //图片上传失败
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
          } else {
            //this.close_loading();
          }
        }).catch((err) => {
          this.close_loading();
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
        });
      }
    },
    //本人確認書類保存
    dataSave() {
      var update_params = {};
      update_params.userCd = this.userCd;//社員コード
      update_params.pivDocDiv = this.selectValue;//本人確認書類
      update_params.pivDocPhoto1 = this.positiveImage.photoPath;//本人書類写真1
      update_params.pivDocPhoto2 = '';
      if (this.selectType == '2') {
        update_params.pivDocPhoto2 = this.reverseImage.photoPath;//本人書類写真2
      }
      update_params.processCd = this.selfDocData.processCd;//処理区分
      update_params.id = this.selfDocData.id;//申請番号
      update_params.updateDate = this.selfDocData.updateDate;//更新日時

      amsApi.i_0009_selfDocSave(update_params).then(res => {
        if (res.code === 202) {
          this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
          //this.$router.push({ path: url.routerUrl_I0002 })
          //画面を再表示する。
          this.showUploadImageControl(this.selectValue);
          this.positiveUrl = '';
          this.reverseUrl = '';
          this.positiveList = [];
          this.reverseList = [];
          this.query();
        } else if (res.code === 308) {
          this.close_loading();
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), this.$t('COMMON.CONFIRM'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: 'true'
          }).then(() => {
            //画面を再表示する。
            this.selectType = '2';
            this.positiveUrl = '';
            this.reverseUrl = '';
            this.positiveList = [];
            this.reverseList = [];
            this.query();
          }).catch(() => {
            this.close_loading();
          })
        } else if (res.code === 311) {
          this.close_loading();
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//処理が失敗しました。
        }
      }).catch((err) => {
        this.close_loading();
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//処理が失敗しました。
      });
    },
    // 图片上传选择
    handleChange(file, fileList, itemName, type) {
      var file_type = file.raw.type
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        if (file.status === "ready") {
          // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
          if (fileList.length === 2) {
            fileList.shift();
          }
        }
        this[itemName + 'Url'] = file.url
        var that = this
        // var photoItem = {}
        this.getBase64(file.raw).then(async res => {
          this.confirmSelectFlag = true;
          // 进行图片压缩获取压缩后的blob文件
          var photo = await that.compressImg(that.base64ToBlob(res))
          let files = new window.File([photo], file.name, { type: file.type })
          //表面写真：image/userInfo/[userCd]/selfDoc/[pivDocDiv]/pivDoc1.拡張子
          //裏面写真：image/userInfo/[userCd]/selfDoc/[pivDocDiv]/pivDoc2.拡張子
          let photoPath = '';
          //拡張子
          var exhibitionName = file.name.split('.')[1];
          if(type == '1') {//表面写真
            photoPath = url.imgUrl_UserInfo + that.userCd + '/selfDoc/' + that.selectValue + '/pivDoc1.'+ exhibitionName;
            this.positiveImage = {};
            this.positiveImage.name = 'pivDoc1.'+ exhibitionName;
            this.positiveImage.files = files;
            this.positiveImage.photoId = type;
            this.positiveImage.photoPath = photoPath;
            this.positiveImage.type = type;
          } else if (type = '2') {//裏面写真
            photoPath = url.imgUrl_UserInfo + that.userCd + '/selfDoc/' + that.selectValue + '/pivDoc2.' + exhibitionName;
            this.reverseImage = {};
            this.reverseImage.name = 'pivDoc2.'+ exhibitionName;
            this.reverseImage.files = files;
            this.reverseImage.photoId = type;
            this.reverseImage.photoPath = photoPath;
            this.reverseImage.type = type;
          }
        })
      }
      
    },
    //单张图片点击
    handlePhotoPreview(file, dialogName) {
      this[dialogName + 'Url'] = file.url;
      this[dialogName + 'Dialog'] = true;
    },
    // 照片删除
    positivePhotoDelete() {
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 変更がありました。一覧に戻りますか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        //组件表示图片清空
        this.positiveList = [];
        //上传用list清空
        this.positiveUrl = '';
        this.positiveDialog = false;
        this.positiveImage = {}
      }).catch(() => {
      })
    },
    // 照片删除
    reversePhotoDelete() {
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 変更がありました。一覧に戻りますか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        //组件表示图片清空
        this.reverseList = [];
        //上传用list清空
        this.reverseUrl = '';
        this.reverseDialog = false;
        this.reverseImage = {}
      }).catch(() => {
      })
    },
    // 图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    // base转blob
    base64ToBlob(file) {
      let byteString;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1])
      } else {
        byteString = unescape(file.split(',')[1])
      }
      let mimeString = file
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },
    // 压缩图片
    compressImg(file) {
      var that = this
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
              h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files)
          };
        };
      })
    },
  },
  mounted() {
    //点击删除按钮之外的地方退出长按模式
    let that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.positiveClick = false;
        that.reverseLongClick = false//是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions'
        && e.target.className != 'el-icon-refresh-left'
        && e.target.className != 'el-icon-refresh-right'
        && e.target.className != 'el-icon-c-scale-to-original'
        && e.target.className != 'el-icon-zoom-in'
        && e.target.className != 'el-icon-zoom-out'
        && e.target.className != 'el-image-viewer__actions__inner'
        && e.target.className != 'el-icon-full-screen'
        && e.target.className != 'el-icon-circle-close'
        && e.target.className != 'el-button el-button--default el-button--small'
      ) {
        //关闭照片查看器
        that.positiveDialog = false
        that.reverseDialog = false
      }
    })
  },
}
</script>
<style >
.i0009-title {
  color: rgb(71, 71, 71);
  text-align: left;
  margin-top: 10px;
  padding-left: 20px;
  height: 40px;
  border-radius: 3px 3px 0 0;
  border: 1px solid rgb(165, 165, 165);
  background-image: linear-gradient(#f0f0f0, #e0e0e0);
}

.i0009-main-border {
  color: rgb(71, 71, 71);
  margin-top: 0px;
  padding: 20px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 0 0 3px 3px;
  border: 1px solid rgb(165, 165, 165);
  border-top: none;
  font-size: 14px;
}
.i0009-row_div-text {
  width: 56px;
  height:40px;
  float: right;
  display:flex;
  align-items: center;
}
.i0009 p {
  font-size: 17px;
  font-weight: 600;
  margin-top: 0px;
  margin-block-start: 10px;
}
/* 左边空图片蓝色边框 */
.i0009_photo_border {
  float: left;
  width: 40%;
  height: 40px;
  margin-left: 0px;
  margin-top: 0px;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 5px;
}
.i0009_photo_upload .el-upload--picture-card {
  width: 35%;
  height: 43px;
  margin-top: 0px;
  margin-left: 6px;
  background-color: #d2eef8;
  border: 1px solid #409eff;
  line-height: 0;
}

/* 图片样式 */
.i0009_photo_upload .el-upload-list--picture-card .el-upload-list__item {
  width: 40%;
  height: 43px;
  margin: 0px 0px 0px 0px;
  border: none;
}

/* 图片上传按钮样式 */
.i0009_photo_upload .el-upload--picture-card i {
  margin-top: 5px;
  color: #409eff;
}
/* 去除上传图片动画 */
.i0009_photo_upload .el-upload-list__item {
  transition: none !important;
}

.i0009-css-btn {
  margin-top: 15px;
  width: 100px;
  height: 40px;
  padding-top: 10px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0009-css-btn:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0009-css-btn:active,
.i0009-css-btn:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}

/*0006778: Staff アプリ　本人確認書類申請　写真削除ボタンを赤×に変更*/
.i0009 .el-icon-circle-close {
  color: #fd270a;
}

</style>


// WEBPACK FOOTER //
// src/module/page/i_0009.vue